"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeDataSelectorId = exports.isNodeVisible = exports.findNodeById = exports.computeCheckedIds = exports.isNodeIndeterminated = exports.isNodeChecked = void 0;
const types_1 = require("./types");
function uncheckNodeFromIDs(node, checkedIds) {
    const findedIdx = checkedIds.findIndex((id) => id === node.id);
    if (findedIdx > -1) {
        checkedIds.splice(findedIdx, 1);
    }
}
function findCheckedAncestor(node, checked) {
    return node
        .getAncestors()
        .find((parent) => checked.find((checkedId) => checkedId === parent.id));
}
function isNodeChecked(node, checked, checkBehavior = types_1.TREE_VIEW_CHECK_BEHAVIOR.simple) {
    if (!node) {
        return false;
    }
    if (checkBehavior !== types_1.TREE_VIEW_CHECK_BEHAVIOR.simple &&
        checkBehavior !== types_1.TREE_VIEW_CHECK_BEHAVIOR.fullHierarchical) {
        return !!findCheckedAncestor(node, checked);
    }
    return checked.some((checkedId) => checkedId === node.id);
}
exports.isNodeChecked = isNodeChecked;
function isNodeIndeterminated(node, checked, checkBehavior) {
    if (!node ||
        node.isAsync() ||
        checkBehavior === types_1.TREE_VIEW_CHECK_BEHAVIOR.simple ||
        checkBehavior === types_1.TREE_VIEW_CHECK_BEHAVIOR.fullHierarchical ||
        checked.length === 0) {
        return false;
    }
    return node.getDescendants().some((child) => checked.includes(child.id));
}
exports.isNodeIndeterminated = isNodeIndeterminated;
function uncheckAncestors(checkedNode, newCheckedIds) {
    const checkedAncestor = findCheckedAncestor(checkedNode, newCheckedIds);
    if (checkedAncestor) {
        checkedNode.getAncestors().every((ancs) => {
            uncheckNodeFromIDs(ancs, newCheckedIds);
            if (ancs === checkedAncestor) {
                return false;
            }
            ancs.getSiblings().forEach((child) => {
                newCheckedIds.push(child.id);
            });
            return true;
        });
    }
}
function checkDescendants(checkedNode, newCheckedIds) {
    checkedNode.getDescendants().forEach((descnd) => uncheckNodeFromIDs(descnd, newCheckedIds));
    newCheckedIds.push(checkedNode.id);
}
function checkAncestors(checkedNode, newCheckedIds, behavior) {
    checkedNode.getAncestors().every((ancs) => {
        var _a, _b, _c, _d;
        if ((_b = (_a = ancs.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.every((child) => isNodeChecked(child, newCheckedIds, behavior))) {
            (_d = (_c = ancs.parent) === null || _c === void 0 ? void 0 : _c.children) === null || _d === void 0 ? void 0 : _d.forEach((child) => uncheckNodeFromIDs(child, newCheckedIds));
            newCheckedIds.push(ancs.parent.id);
            return true;
        }
        return false;
    });
}
function computeCheckedIds(behavior = types_1.TREE_VIEW_CHECK_BEHAVIOR.simple, checkedNode, checkedIds) {
    const newCheckedIds = [...checkedIds];
    switch (behavior) {
        case types_1.TREE_VIEW_CHECK_BEHAVIOR.hierarchical:
            if (isNodeChecked(checkedNode, newCheckedIds, behavior)) {
                uncheckAncestors(checkedNode, newCheckedIds);
                return newCheckedIds;
            }
            checkDescendants(checkedNode, newCheckedIds);
            checkAncestors(checkedNode, newCheckedIds, behavior);
            return newCheckedIds;
        case types_1.TREE_VIEW_CHECK_BEHAVIOR.descendantsHierarchical:
            if (isNodeChecked(checkedNode, newCheckedIds, behavior)) {
                uncheckAncestors(checkedNode, newCheckedIds);
                return newCheckedIds;
            }
            checkDescendants(checkedNode, newCheckedIds);
            return newCheckedIds;
        case types_1.TREE_VIEW_CHECK_BEHAVIOR.fullHierarchical:
            if (isNodeChecked(checkedNode, newCheckedIds, behavior)) {
                const descIds = checkedNode.getDescendants().map((node) => node.id);
                return newCheckedIds.filter((checkedId) => !descIds.includes(checkedId));
            }
            checkedNode.getAncestors().forEach((node) => {
                if (node === checkedNode || !isNodeChecked(node, newCheckedIds, behavior)) {
                    newCheckedIds.push(node.id);
                }
            });
            return newCheckedIds;
        default:
            if (checkedIds.find((id) => id === checkedNode.id)) {
                return checkedIds.filter((id) => id !== checkedNode.id);
            }
            return [...checkedIds, checkedNode.id];
    }
}
exports.computeCheckedIds = computeCheckedIds;
function findNodeById(id, nodes) {
    for (const node of nodes) {
        const foundNode = node.getById(id);
        if (foundNode) {
            return foundNode;
        }
    }
    return undefined;
}
exports.findNodeById = findNodeById;
function isNodeVisible(node, expandedIds) {
    if (!node.parent) {
        return true;
    }
    const ancestors = node.getAncestors();
    const expandedIdsSet = new Set(expandedIds);
    return ancestors
        .filter((item) => item.id !== node.id)
        .every((item) => expandedIdsSet.has(item.id));
}
exports.isNodeVisible = isNodeVisible;
function getNodeDataSelectorId(dataSelectorId, node) {
    return `${dataSelectorId}-node${node
        .getAncestors()
        .reverse()
        .map((node) => `-id${node.id}`)
        .join('')}`;
}
exports.getNodeDataSelectorId = getNodeDataSelectorId;
//# sourceMappingURL=selectionHelpers.js.map